import { render, staticRenderFns } from "./newsItem.vue?vue&type=template&id=703c3133&scoped=true"
import script from "./newsItem.vue?vue&type=script&lang=js"
export * from "./newsItem.vue?vue&type=script&lang=js"
import style0 from "./newsItem.vue?vue&type=style&index=0&id=703c3133&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703c3133",
  null
  
)

export default component.exports